import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseHttpService } from '@ems/api';
import { CookieService } from 'ngx-cookie-service';
import { HttpCacheManager } from '@ngneat/cashew';

@Injectable({
  providedIn: 'root'
})
export class ChangelogService extends BaseHttpService {
  constructor(
    http: HttpClient,
    cookieService: CookieService,
    manager: HttpCacheManager,
  ) {
    super(http, cookieService, manager);
  }

  getList(entity: string, id: number, queryParams?: any): Observable<any> {
    const params = {
      ...queryParams
    }
    return this.getAll(entity + '/' + id + '/history', params);
  }
}
